import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input, InputType } from 'react-magma-dom';
import { SearchIcon } from 'react-magma-icons';
import { maxLength } from '../../../../utilities/validators';

const maxMessageLength = 25;
const Search = ({ setMessage }) => {
  const [value, setValue] = useState('');

  const handleSearch = () => {
    if (value.length < maxMessageLength) {
      setMessage(value);
    }
  };

  const handleChange = event => {
    setValue(event.target.value);
  };

  const handleColumnVariableNameError = () => maxLength(maxMessageLength)(value);

  return (
    <div>
      <Input
        testId="search-input"
        placeholder="Search"
        icon={<SearchIcon />}
        errorMessage={handleColumnVariableNameError()}
        onChange={handleChange}
        type={InputType.search}
        onIconClick={handleSearch}
        iconAriaLabel="Search"
        isLabelVisuallyHidden
        labelText="Input string for filtering Datasets"
        onKeyPress={e => e.key === 'Enter' && handleSearch()}
      />
    </div>
  );
};

Search.propTypes = {
  setMessage: PropTypes.func.isRequired
};


export default Search;
